/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pm_Applied_BadgeInputs */

const cs_pm_applied_badge = /** @type {(inputs: Pm_Applied_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uloženo ${i?.n}`)
};

const en_pm_applied_badge = /** @type {(inputs: Pm_Applied_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Saved {n}" |
*
* @param {Pm_Applied_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_applied_badge = /** @type {((inputs: Pm_Applied_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Applied_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_applied_badge(inputs)
	return cs_pm_applied_badge(inputs)
});